import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { Config } from "@cbcore/services/config/config.service";
import { CalculationsService } from "@cbcore/services/utils/calculations/calculations.service";
import { RacingUnitsDistributionBase } from '../base/racing-units-distribution.base';

@Component({
    selector: 'ud-horse-racing',
    templateUrl: './default/horse-racing/horse-racing.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class HorseRacingComponent extends RacingUnitsDistributionBase {
  constructor(
    protected override _config: Config,
    protected override _calculationsService: CalculationsService
  ) {
    super(_config, _calculationsService);
  }

  protected override initializeUrls(): void {
    this.silksUrl = this._config.CONFIG.silksUrl;
    this.bucket = this._config.CONFIG.silkBucket;
  }
}